import React, { useState } from "react";
import { Button, Modal, Input } from "antd";
import { ErrorPopup } from "../../../../utilities/swal";
import { IBusDetail, ISeatDetail, ITripDetail } from "../../../../models/trip";
import { addExtraSeatApi } from "../../../../apis/bus.api";
import { useModalLockScroll } from "../../../../hooks/useModalLockScroll";

interface ButtonAddExtraSeatProps {
  bus: IBusDetail;
  onSetTrip: React.Dispatch<React.SetStateAction<ITripDetail | null>>;
}

const ButtonAddExtraSeat: React.FC<ButtonAddExtraSeatProps> = ({
  bus,
  onSetTrip,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [numberSeat, setNumberSeat] = useState<number | "">("");
  useModalLockScroll(isModalOpen);
  const showModal = () => setIsModalOpen(true);

  const handleCancel = () => {
    if (loading) return;
    setIsModalOpen(false);
  };

  const handleAddSeat = async () => {
    if (numberSeat === "" || numberSeat <= 0) {
      ErrorPopup("Số ghế phải là số hợp lệ");
      return;
    }

    try {
      setLoading(true);

      const rs = await addExtraSeatApi(
        bus?._id,
        bus?.tripId,

        numberSeat
      );

      if (rs?.success && Array.isArray(rs?.data)) {
        const newSeats = rs.data;

        onSetTrip((prev) => {
          if (!prev) return prev;

          return {
            ...prev,
            buses: prev.buses.map((b) => {
              if (b._id !== bus._id) return b;

              const currentSeats = b.seats || [];

              // ✅ Merge không trùng
              const seatMap = new Map<string, ISeatDetail>();

              [...currentSeats, ...newSeats].forEach((s) => {
                if (s?._id) seatMap.set(s._id, s);
              });

              return {
                ...b,
                seats: Array.from(seatMap.values()),
              };
            }),
          };
        });
        setIsModalOpen(false);
      } else {
        ErrorPopup("Thêm ghế thất bại", rs?.message || "");
      }
    } catch (error: any) {
      ErrorPopup("Thêm ghế thất bại", error?.message || "");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Button onClick={showModal} className="font-medium w-full">
        Thêm ghế dư
      </Button>

      <Modal
        title={`Thêm ghế cho xe số: ${bus.busNumber}`}
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={handleAddSeat}
        okText="Thêm"
        cancelText="Hủy"
        okButtonProps={{ loading }}
        cancelButtonProps={{ disabled: loading }}
      >
        <div className="flex flex-col gap-2">
          <label className="font-medium">Số ghế cần thêm</label>
          <Input
            type="number"
            placeholder="Nhập số ghế muốn thêm"
            value={numberSeat}
            onChange={(e) => {
              const value = e.target.value;
              setNumberSeat(value === "" ? "" : Number(value));
            }}
            disabled={loading}
          />
        </div>
      </Modal>
    </div>
  );
};

export default ButtonAddExtraSeat;
